import { useQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { getPreloadQuery } from "@/shared/gql/apollo-client";
import type { SourcingWebsitesSearch } from "@/pages/admin-sourcing-websites/model/search-params";

const FetchSourcingWebsites = graphql(`
  query FetchSourcingWebsites($input: SearchSourcingWebsitesInput!) {
    superAdmin {
      sourcingWebsites(input: $input) {
        paginatorInfo {
          total
        }
        data {
          id
          name
          url
          domain
          urlStatus
          lastDiscoveredAt
          organisation {
            id
            name
          }
        }
      }
    }
  }
`);

export const SOURCING_WEBSITES_PAGE_SIZE = 50;

export const toSourcingWebsitesInput = (search: SourcingWebsitesSearch) => ({
  search: search.q,
  urlStatus: search.status,
  tenderPageFound: search.tenderPageFound,
  paginator: {
    page: search.page ?? 1,
    take: SOURCING_WEBSITES_PAGE_SIZE,
  },
});

export const useFetchSourcingWebsites = (search: SourcingWebsitesSearch) =>
  useQuery(FetchSourcingWebsites, {
    variables: { input: toSourcingWebsitesInput(search) },
  });

export const preloadSourcingWebsites = (search: SourcingWebsitesSearch) => {
  getPreloadQuery()(FetchSourcingWebsites, {
    variables: { input: toSourcingWebsitesInput(search) },
  });
};
